import {
  AnnotationUpdateDetails,
  DrawingType,
  minDrawingHeight,
  minDrawingWidth,
} from '../constants';
import { getCanvasPointerPosition } from '../utils';
import { getNewId } from 'utils/Global';
import { useModalHandlers } from 'components/modal';
import React from 'react';
import { useWellDrawingFontsPreferences } from 'redux/hooks/well';
import TransformPoints from 'components/plateviewer/well/TransformPoints';

let annotationDrawing: AnnotationUpdateDetails = null;
let isDrawingFirstClick: boolean = false;

const setAnnotationText = (text) => {
  annotationDrawing = { ...annotationDrawing, text };
};

export const useAnnotationCreateHandlers = (
  tpObject: TransformPoints,
  onCloseAnnotationModal?: () => void,
) => {
  const { showAwaitableModal, hideModal } = useModalHandlers();
  const { fontFamily, fontSize } = useWellDrawingFontsPreferences();

  const resolveModal = () => {
    hideModal();
    annotationDrawing = { ...annotationDrawing, isNewDrawing: false };
    if (onCloseAnnotationModal) {
      onCloseAnnotationModal();
    }
  };
  const closeAnnotationModal = () => {
    hideModal();
    if (onCloseAnnotationModal) {
      onCloseAnnotationModal();
    }
  };
  const onMouseDown: (e) => { drawing: AnnotationUpdateDetails; type: DrawingType } = (
    e,
  ) => {
    const { x, y } = getCanvasPointerPosition(e);
    const [dbX, dbY] = tpObject.FromCanvasToDb(x, y);
    annotationDrawing = {
      id: getNewId(),
      x,
      y,
      dbX,
      dbY,
      width: 0,
      height: 0,
      bgColor: '255, 255, 225',
      fontFamily,
      size: fontSize,
      text: '',
      expanded: true,
      zIndex: 0,
      isNewDrawing: true,
    };

    isDrawingFirstClick = true;
    return null;
  };

  const onMouseMove: (e) => {
    drawing: AnnotationUpdateDetails;
    type: DrawingType;
    isDrawingFirstClick: boolean;
  } = (e) => {
    const { x, y } = getCanvasPointerPosition(e);

    annotationDrawing = {
      ...annotationDrawing,
      width:
        x - annotationDrawing.x < minDrawingWidth
          ? minDrawingWidth
          : x - annotationDrawing.x,
      height:
        y - annotationDrawing.y < minDrawingHeight
          ? minDrawingHeight
          : y - annotationDrawing.y,
    };

    const drawingData = {
      drawing: annotationDrawing,
      type: DrawingType.Annotation,
      isDrawingFirstClick,
    };
    isDrawingFirstClick = false;
    return drawingData;
  };

  const onMouseUp = async (
    e,
  ): Promise<{ drawing: AnnotationUpdateDetails; type: DrawingType }> => {
    if (!isDrawingFirstClick) {
      await showAwaitableModal({
        body: (
          <textarea
            id="annotation-onmouseup-textarea"
            className="textArea w-full h-[150px] resize-none"
            name="minValue"
            onChange={(e) => {
              const text = e.target.value;
              setAnnotationText(text);
            }}
          />
        ),
        id: 'annotation-onmouseup-modal',
        isOkOnly: true,
        onOk: resolveModal,
        onHide: closeAnnotationModal,
        isModalEscapeable: false,
        resolveModalOnHide: true,
      });
      return { drawing: annotationDrawing, type: DrawingType.Annotation };
    }
    isDrawingFirstClick = false;
    return null;
  };

  return { onMouseDown, onMouseMove, onMouseUp: onMouseUp };
};
